export default {
    "cancel": "İptal",
    "vanAddressEditDetail": {
        "label": "adres",
        "placeholder": "Sokak numarası, kat oda numarası vb."
    },
    "save": "kaydetmek",
    "vanAddressList": {
        "add": "adres Ekle"
    },
    "delete": "silmek",
    "telInvalid": "Lütfen doğru telefon numarasını girin",
    "tel": "Telefon",
    "telEmpty": "Lütfen telefon numarasını giriniz",
    "nameEmpty": "lütfen adınızı girin",
    "vanCoupon": {
        "unlimited": "kullanım kısıtlaması yok"
    },
    "lang": "中文",
    "vanCalendar": {
        "startEnd": "başlangıç \u200b\u200bbitiş",
        "weekdays": [
            "Gün",
            "Bir",
            "İki",
            "Üç",
            "Dört",
            "Beş",
            "Altı"
        ],
        "start": "Başlat",
        "title": "Başlık",
        "confirm": "onaylamak",
        "end": "Bitiş"
    },
    "vanSubmitBar": {
        "label": "tüm:"
    },
    "vanContactCard": {
        "addText": "Kişileri ekleyin"
    },
    "loading": "Yükleniyor...",
    "vanCascader": {
        "select": "lütfen seç"
    },
    "confirmDelete": "Silmek istediğine emin misin",
    "vanContactList": {
        "addText": "yeni bağlantı"
    },
    "confirm": "onaylamak",
    "vanCouponCell": {
        "title": "kupon",
        "tips": "Müsait değil"
    },
    "vanPullRefresh": {
        "loosing": "yenile bırak...",
        "pulling": "Yenilemek için aşağıya çekin..."
    },
    "nameInvalid": "Lütfen geçerli bir isim girin",
    "name": "İsim",
    "vanPagination": {
        "next": "sonraki Sayfa",
        "prev": "önceki sayfa"
    },
    "vanCouponList": {
        "empty": "kupon yok",
        "enable": "kullanılabilir",
        "disabled": "Müsait değil",
        "exchange": "değiş tokuş",
        "placeholder": "Lütfen promosyon kodunu girin",
        "close": "kupon yok"
    },
    "vanAddressEdit": {
        "area": "alan",
        "namePlaceholder": "Alıcı ismi",
        "telPlaceholder": "Alıcının cep telefonu numarası",
        "areaEmpty": "bölge Seç",
        "postalEmpty": "Yanlış posta kodu biçimi",
        "addressEmpty": "Lütfen ayrıntılı adresi doldurun",
        "postal": "posta kodu",
        "areaPlaceholder": "İl/Şehir/Bölge Seçin",
        "defaultAddress": "varsayılan gönderim adresi olarak ayarla"
    },
    "complete": "Bitiş"
}